import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import DriverDashboard from "@/pages/DriverDashboard";
import TransportForm from "@/pages/TransportForm";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminDrivers from "@/pages/AdminDrivers";
import AdminEmailLogs from "@/pages/AdminEmailLogs";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/chauffeur"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/chauffeur" element={<ProtectedRoute><DriverDashboard /></ProtectedRoute>} />
          <Route path="/chauffeur/nouveau" element={<ProtectedRoute><TransportForm /></ProtectedRoute>} />
          <Route path="/chauffeur/transport/:id" element={<ProtectedRoute><TransportForm /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute admin><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/transports" element={<ProtectedRoute admin><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/transports/nouveau" element={<ProtectedRoute admin><TransportForm /></ProtectedRoute>} />
          <Route path="/admin/transports/:id" element={<ProtectedRoute admin><TransportForm /></ProtectedRoute>} />
          <Route path="/admin/chauffeurs" element={<ProtectedRoute admin><AdminDrivers /></ProtectedRoute>} />
          <Route path="/admin/envois" element={<ProtectedRoute admin><AdminEmailLogs /></ProtectedRoute>} />

          <Route path="/" element={<RootRedirect />} />
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
